import React from 'react';
import { useTranslation } from 'react-i18next';
import Vale from '../Vales';

const ValesActivados = ({ valesAct, isMobile, setVisible, setPromocion }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="divider" />
      <h2 className="bloque-datos__title u-text-brand">
        <span className="divider__square brand-color" />
        <span className="u-margin-right">{t('vales.activados')}</span>
      </h2>

      <div className="listado-vales listado-vales__activos">
        {valesAct &&
          valesAct.map((valeData, index) => (
            <Vale
              setPromocion={setPromocion}
              preActivado={false}
              key={`vale-${valeData.valeEAN}`}
              data={valeData}
              cargarVales={valesAct}
              valeIndex={isMobile ? 0 : index}
              showCondLegales={setVisible}
            />
          ))}
      </div>
    </>
  );
};

export default ValesActivados;
